import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import appVersion from './version.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Echo current app version on load
try {
  if (appVersion && appVersion.version) {
    // Minimal console output as requested by user preferences
    console.log(`App version: ${appVersion.version}`);
  }
} catch (_) {
  // no-op
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
